/**
 * @author Munnaf Hossain Mondal <munnaf.hossain@redappletech.com>
 * @version 2.0.1
 * create date : Friday 9 May 2023 12∶18∶31 PM
 * last Update : Friday 26 Jun 2023 04∶18∶31 PM
 * Note:  Main file to control 3D Room
 * Last Update By : Munnaf Hossain Mondal
 */




/******************* URL FOR STORE VIEW *****************/
/*
for shoe room
http://localhost:8080/?s_slug=eye-glass-store-2

# Run the local server at localhost:8080
npm run dev

# Build for production in the dist/ directory
npm run build

just extract the Zip and run. If getting any error the run- npm install

*/
/************************************************************ */

import './style.css'
import * as THREE from 'three'
import { IndoorControls } from './three_utils/IndoorControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { MathUtils, Vector3 } from 'three'
let camera, scene, renderer, controls;
let viewport;
let mouseHelper = new THREE.Object3D();



const loadingScreen = document.getElementById('loading-screen');
const loadingManager = new THREE.LoadingManager(() => {
    loadingScreen.classList.add('fade-out');
    // optional: remove loader from DOM via event listener
    loadingScreen.addEventListener('transitionend', onTransitionEnd);
});

function onTransitionEnd(event) {
    const element = event.target;
    element.remove();
}
// Draco loader
const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

const raycaster = new THREE.Raycaster();
let objects = [];
objects.length = 0;
let isMouseOnProduct = false;
let path = window.location.pathname;
let storeglb_link;
//for local run
// let page = Helpers.getUrlVars()["s_slug"]

//for live server run
let pagelink = window.location.href
pagelink=pagelink.replace("http:","");
pagelink=pagelink.replace("https:","");
pagelink=pagelink.replace("\/\/","");
let page_params=pagelink.split("/");
console.log(page_params);
let page = page_params[1];

storeglb_link = `https://ralbaassetstorage.s3.us-east-2.amazonaws.com/store/${page}.glb`
//for production run *******************************************************
//  let page = store_slug_url;

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName designRoom
    * @functionPurpose  load room with ground seleted for control
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

async function designRoom() {
    let gltfStore = await gltfLoader.loadAsync(storeglb_link)
    gltfStore.scene.traverse(function (child) {
        if (child.name === "bottom_wall" || child.name === "Floor" || child.name == "bottom") {
            controls.ground = child;
        }
    })
    scene.add(gltfStore.scene)
}



// Initialise 
init();
animate();
designRoom();

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName init
    * @functionPurpose  this function use to initilize three.js functionality
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function init() {
    camera = new THREE.PerspectiveCamera(80, window.innerWidth / window.innerHeight, 1, 200);
    camera.position.y = 10;
    camera.rotation.set(0, Math.PI / 2, 0);
    scene = new THREE.Scene();
    scene.background = new THREE.Color('grey');

    const light = new THREE.HemisphereLight(0xeeeeff, 0x777788, 2);
    light.position.set(0.5, 1, 0.75);
    scene.add(light);

    const directionalLight = new THREE.DirectionalLight('0xfffafa', 0.5);
    directionalLight.position.set(0, 1.1, 0)
    scene.add(directionalLight);
    // document.addEventListener('mousedown', onMouseDown);
    // document.addEventListener('mouseup', onMouseUp);
    // document.addEventListener('mousemove', onMouseMove, false)
    // document.addEventListener('wheel', onDocumentMouseWheel);

    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    renderer.outputEncoding = THREE.sRGBEncoding
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.85;
    renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(renderer.domElement);

    controls = new IndoorControls(camera, renderer.domElement);
    console.log('================================',controls)
    let helperMaterial = new THREE.MeshBasicMaterial();
    helperMaterial.transparent = false;
    helperMaterial.opacity = 0.5;
    mouseHelper = new THREE.Mesh(new THREE.CircleBufferGeometry(0.7, 32), helperMaterial);

    viewport = document.getElementById('viewport');
    viewport.appendChild(renderer.domElement);
    // controls.addEventListener('move', function (event) {
    //     scene.add(mouseHelper);
    //     let intersect = event.intersect;
    //     mouseHelper.position.set(0, 0, 0);
    //     mouseHelper.lookAt(new Vector3(0, 50, 0))
    //     mouseHelper.position.copy(new Vector3(intersect.point.x, intersect.point.y + 0.001, intersect.point.z));
    //     mouseHelper.position.addScaledVector(intersect.face.normal, 0.001);

    // });

    // viewport.ondragover = function (event) {
    //     // console.log("============= ON DRAG OVER =================");
    //     event.preventDefault();
    // };

    // viewport.ondrop = function (event) {
    //     // console.log("============= ON DROP =================");
    //     event.preventDefault();
    // };
    // window.addEventListener('resize', onWindowResize);
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onWindowResize
    * @functionPurpose  this function use to onWindowResize
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */



function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onDocumentMouseWheel
    * @functionPurpose  this function use to onDocumentMouseWheel
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function onDocumentMouseWheel(event) {
    const fov = camera.fov + event.deltaY * 0.05;
    camera.fov = THREE.MathUtils.clamp(fov, 10, 75);
    camera.updateProjectionMatrix();
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onMouseUp
    * @functionPurpose  this function use to onMouseUp
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function onMouseUp(event) {
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onMouseDown
    * @functionPurpose  this function use to onMouseDown
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function onMouseDown(event) {
    // const mouse = {
    //     x: (event.clientX / renderer.domElement.clientWidth) * 2 - 1,
    //     y: -(event.clientY / renderer.domElement.clientHeight) * 2 + 1
    // }
    // // console.log("Mouse Down Called")
    // raycaster.setFromCamera(mouse, camera);

    // const intersects = raycaster.intersectObjects(objects, false)
    // if (intersects.length > 0) {

    //         for (let i in objects) {
    //             if (objects[i] == intersects[0].object) {
    //               // console.log("Object Number is " + i); // {a: 5, b: 6}
    //             }
    //           }
    // }

}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onMouseMove
    * @functionPurpose  this function use to onMouseMove
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function onMouseMove(event) {

    const mouse = {
        x: (event.clientX / renderer.domElement.clientWidth) * 2 - 1,
        y: -(event.clientY / renderer.domElement.clientHeight) * 2 + 1
    }


    raycaster.setFromCamera(mouse, camera);

    const intersects = raycaster.intersectObjects(objects, false)
    if (intersects.length > 0) {
        // console.log(objects.length + " " + intersects.length)
        // console.log(intersects[0].object)
        // console.log(intersects[0].object.userData.name + " " + intersects[0].distance + " ")
        controls.enabled = false;
        isMouseOnProduct = true;
        document.body.style.cursor = 'pointer'
    } else {

        document.body.style.cursor = 'default'
        controls.enabled = true;
        isMouseOnProduct = false;
    }
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName animate
    * @functionPurpose  this function use to animate whole project. this will run all time any changes
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

function animate() {
    requestAnimationFrame(animate);
    controls.update();
    camera.position.x = MathUtils.clamp(camera.position.x, -39, 37);
    camera.position.z = MathUtils.clamp(camera.position.z, -25, 20);
    renderer.render(scene, camera);
}




